export const { NODE_ENV: environment } = process.env;

export const LINEUP_LIMIT = 16;

// Host of the single club statistics deployment (own site + own database).
const STATISTICS_MODE_HOST = 'statistics.arena.total-waterpolo.com';
const STAGING_HOST = 'staging.arena.total-waterpolo.com';

export const STATISTICS_APP_TITLE = 'Total Waterpolo Statistics Portal';

/*
 * Statistics mode only unlocks extra shortcuts in this app (opponent teams with
 * placeholder players). The API, production and staging behave exactly the same,
 * which is why the switch lives in the client and not in appsettings.
 */
export const isStatisticsMode = (): boolean =>
    process.env.REACT_APP_STATISTICS_MODE === 'true' ||
    window.location.hostname === STATISTICS_MODE_HOST;

/** Club Insights: statistics portal, local STATISTICS_MODE, or staging so others can test. */
export const isInsightsEnabled = (): boolean =>
    isStatisticsMode() || window.location.hostname === STAGING_HOST;

